import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _Getters;

import * as types from "@/store/constants/types";
var Getters = (_Getters = {}, _defineProperty(_Getters, types.GETTER_PALM_PRINT_DATA, function (state, payLoad) {
  return state.palm_print_data;
}), _defineProperty(_Getters, types.GETTER_FACE_READING_DATA, function (state, payLoad) {
  return state.face_reading_data;
}), _defineProperty(_Getters, types.GETTER_READING_LIST, function (state, payLoad) {
  return state.reading_data_list;
}), _Getters);
export default Getters;